var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "li",
    {
      staticClass: "selected-treatments__card",
      class: { "has-error": _vm.hasError },
      attrs: { tabindex: "-1", "data-uuid": _vm.treatment.uuid },
    },
    [
      _c("div", { staticClass: "selected-treatments__card-body" }, [
        _c("div", { staticClass: "selected-treatments__card-order" }, [
          _vm._v("\n      " + _vm._s(_vm.treatment.order) + "\n    "),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "selected-treatments__card-heading" }, [
          _c("h3", { staticClass: "selected-treatments__card-title" }, [
            _vm._v(
              "\n        " +
                _vm._s(_vm.treatment.sitecoreTreatmentDetails.title) +
                "\n      "
            ),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "selected-treatments__card-category" }, [
            _vm._v(
              "\n        " +
                _vm._s(_vm.treatment.treatmentCategory.title) +
                "\n      "
            ),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "selected-treatments__card-duration" }, [
          _vm._v(
            "\n      " +
              _vm._s(_vm.treatment.selectedTimeSlot.duration) +
              "\n    "
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "selected-treatments__card-price" }, [
          _vm._v(
            "\n      " +
              _vm._s(
                _vm.getTreatmentPriceFormatted({
                  treatment: _vm.treatment.selectedTimeSlot,
                  checkTaxes: true,
                })
              ) +
              "\n    "
          ),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "selected-treatments__card-therapist input dropdown" },
          [
            _c(
              "select",
              {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.preferredGenderSelected,
                    expression: "preferredGenderSelected",
                  },
                ],
                staticClass: "selected-treatments__card-select",
                attrs: {
                  id: "preferredGender",
                  name: "preferredGender",
                  "data-field-type": "DropdownList",
                },
                on: {
                  change: function ($event) {
                    var $$selectedVal = Array.prototype.filter
                      .call($event.target.options, function (o) {
                        return o.selected
                      })
                      .map(function (o) {
                        var val = "_value" in o ? o._value : o.value
                        return val
                      })
                    _vm.preferredGenderSelected = $event.target.multiple
                      ? $$selectedVal
                      : $$selectedVal[0]
                  },
                },
              },
              _vm._l(_vm.preferredGenderOptions, function (gender) {
                return _c(
                  "option",
                  { key: gender.value, domProps: { value: gender.value } },
                  [_vm._v("\n          " + _vm._s(gender.label) + "\n        ")]
                )
              }),
              0
            ),
            _vm._v(" "),
            _c(
              "label",
              {
                staticClass: "floating select-label",
                attrs: { for: "preferredGender" },
              },
              [
                _vm._v(
                  "\n        " +
                    _vm._s(
                      _vm.tc(
                        "spaSoft.step1.selectedTreatments.preferedTherapistGenderLabel"
                      )
                    ) +
                    "\n\n      "
                ),
              ]
            ),
          ]
        ),
      ]),
      _vm._v(" "),
      _vm.treatmentAddOns.length
        ? _c("TreatmentAddOnsList", {
            attrs: { "treatment-add-ons": _vm.treatmentAddOns },
          })
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "selected-treatments__card-controls" }, [
        _vm.check.isLgAndDown
          ? _c(
              "button",
              {
                staticClass: "selected-treatments__card-controls-close",
                attrs: {
                  type: "button",
                  "aria-label": _vm.tc(
                    "spaSoft.step1.selectedTreatments.ariaLabelRemoveTreatment",
                    {
                      treatmentTitle:
                        _vm.treatment.sitecoreTreatmentDetails.title,
                      guestNumber: Number(_vm.currentGuestNumber) + 1,
                    }
                  ),
                },
                on: { click: _vm.handleRemoveClick },
              },
              [_c("span", { staticClass: "icon-close" })]
            )
          : _vm._e(),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "selected-treatments__card-controls-arrows" },
          [
            _c(
              "button",
              {
                staticClass: "selected-treatments__card-controls-arrows-up",
                class: { disabled: !_vm.canMoveUp(_vm.treatment.order) },
                attrs: {
                  type: "button",
                  disabled: !_vm.canMoveUp(_vm.treatment.order),
                  "aria-label": _vm.tc(
                    "spaSoft.step1.selectedTreatments.ariaLabelMoveTreatmentUp",
                    {
                      treatmentTitle:
                        _vm.treatment.sitecoreTreatmentDetails.title,
                    }
                  ),
                },
                on: {
                  click: function ($event) {
                    return _vm.changeTreatmentOrder(_vm.treatment.uuid, "up")
                  },
                },
              },
              [_c("span", { staticClass: "icon-arrow-up-black" })]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "selected-treatments__card-controls-arrows-down",
                class: { disabled: !_vm.canMoveDown(_vm.treatment.order) },
                attrs: {
                  type: "button",
                  disabled: !_vm.canMoveDown(_vm.treatment.order),
                  "aria-label": _vm.tc(
                    "spaSoft.step1.selectedTreatments.ariaLabelMoveTreatmentDown",
                    {
                      treatmentTitle:
                        _vm.treatment.sitecoreTreatmentDetails.title,
                    }
                  ),
                },
                on: {
                  click: function ($event) {
                    return _vm.changeTreatmentOrder(_vm.treatment.uuid, "down")
                  },
                },
              },
              [_c("span", { staticClass: "icon-arrow-down-black" })]
            ),
          ]
        ),
        _vm._v(" "),
        _vm.check.isLgAndUp
          ? _c(
              "button",
              {
                staticClass: "selected-treatments__card-controls-close",
                attrs: {
                  type: "button",
                  "aria-label": _vm.tc(
                    "spaSoft.step1.selectedTreatments.ariaLabelRemoveTreatment",
                    {
                      treatmentTitle:
                        _vm.treatment.sitecoreTreatmentDetails.title,
                      guestNumber: Number(_vm.currentGuestNumber) + 1,
                    }
                  ),
                },
                on: { click: _vm.handleRemoveClick },
              },
              [_c("span", { staticClass: "icon-close" })]
            )
          : _vm._e(),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }